import axios from "axios";
import { logClientError } from "@/lib/errorLogger";

let installed = false;

export function setupErrorTracking() {
  if (installed) return;
  installed = true;

  // 1) window.onerror — uncaught wyjatki w sync kodzie
  const prevOnError = window.onerror;
  window.onerror = function (msg, src, lineno, colno, err) {
    try {
      logClientError({
        source: `window.onerror:${src || "unknown"}:${lineno || 0}`,
        message: String(msg || err?.message || "Unknown error"),
        severity: "high",
        stack_trace: err?.stack || `${src}:${lineno}:${colno}`,
      });
    } catch (_) {}
    if (typeof prevOnError === "function") return prevOnError.apply(this, arguments);
  };

  // 2) unhandledrejection — promisy ktore rzucily bez catch
  window.addEventListener("unhandledrejection", (event) => {
    try {
      const reason = event.reason;
      const message = reason?.message || String(reason || "Unhandled promise rejection");
      const stack = reason?.stack || "";
      logClientError({
        source: "unhandledrejection",
        message,
        severity: "high",
        stack_trace: stack,
      });
    } catch (_) {}
  });

  // 3) Axios interceptor — wszystkie 5xx (server errors) trafiaja do monitora.
  //    4xx pomijamy bo to czesto oczekiwane (np. 401 dla nielogowanych).
  axios.interceptors.response.use(
    (response) => response,
    (error) => {
      try {
        const status = error?.response?.status;
        const cfg = error?.config || {};
        const url = cfg?.url || "unknown";
        const method = (cfg?.method || "get").toUpperCase();

        // tylko serwerowe bledy + network errors (status === undefined)
        const isServerError = status === undefined || status >= 500;
        // pomin nasz wlasny logging endpoint zeby nie zrobic petli
        const isMonitorEndpoint = url.includes("/monitor/client-error") || url.includes("/monitor/user-report");

        if (isServerError && !isMonitorEndpoint) {
          const body = error?.response?.data;
          const message = `${method} ${url} -> ${status || "NETWORK_ERROR"}: ${
            typeof body === "string" ? body.substring(0, 200) : body?.detail || error?.message || "Unknown"
          }`;
          logClientError({
            source: `axios:${method}:${url.substring(0, 100)}`,
            message,
            severity: status >= 500 ? "high" : "medium",
            stack_trace: error?.stack || "",
            additional: {
              status,
              request_body_preview: typeof cfg?.data === "string" ? cfg.data.substring(0, 500) : undefined,
            },
          });
        }
      } catch (_) {}
      return Promise.reject(error);
    }
  );
}
